import styled from 'styled-components'
import { themeGet } from 'styled-system'
import { HeaderFour, BodyCopy } from 'secondstep-components'

export const CalloutBoxContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 1rem;
  margin-bottom: ${themeGet('spacing.turquoise20_1_25rem', '1.25rem')};
  border-radius: 0.688rem;
  background-color: ${themeGet('callouts.backgroundColor', 'colors.white')};
  border: ${themeGet('colors.gray200', 'none')};
  border-style: solid;
  border-width: 2px;
`

export const IconContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 0.8rem;
  flex-shrink: 0;

  svg {
    width: 2.25rem;
    height: 2.25rem;
  }
`

export const TextContent = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
`

export const Title = styled(HeaderFour).attrs(({ color }) => ({
  color: `${color} !important`,
}))`
  font-family: ${themeGet('font.sharpSlab.semibold')};
  font-size: 1rem;
  line-height: 1rem;
`

export const Description = styled(BodyCopy)`
  color: ${themeGet('colors.darkGray')};
  font-family: ${themeGet('textFontFamily', 'fontFamily')};
  font-size: 1rem;
  line-height: 1rem;
  margin: 0;
  font-style: italic;
`
